export default {
    open: "Responda agora",
    approve: "Aprovar agora",
    impersonation: {
        title: "Você está fazendo um pedido em nome de «{name}»",
        cta: "Volte para mim mesmo",
    },
    "You have an unapproved orders": "Você tem pedidos para aprovar",
    "You have orders to approve": "Você tem pedidos para aprovar"
}